import { render } from "./ruleSetting.vue?vue&type=template&id=8ec819be&scoped=true"
import script from "./ruleSetting.vue?vue&type=script&lang=js"
export * from "./ruleSetting.vue?vue&type=script&lang=js"

import "./ruleSetting.vue?vue&type=style&index=0&id=8ec819be&lang=less&scoped=scoped"

import exportComponent from "E:\\claude_code\\healthmall\\tongue_desktop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ec819be"]])

export default __exports__